
        document.addEventListener('DOMContentLoaded', function () {
          // Start with 30 minutes
          smoothTimer(30);
        });

        /**
         * Smooth countdown timer with separate minute and second updates
         * @param {number} minutes - Initial minutes to count down from
         */
        function smoothTimer(minutes) {
          // Storage key
          const STORAGE_KEY = 'smoothTimerEndTime';

          // Convert minutes to total seconds
          const TOTAL_SECONDS = minutes * 60;

          // Track interval
          let timerId = null;
          let prevMinutes = -1;
          let prevSeconds = -1;

          // Find all timer containers
          const timerContainers = document.querySelectorAll('.timer-container');
          let hasRevealedTimers = false;

          function revealTimers() {
            if (hasRevealedTimers) return;
            hasRevealedTimers = true;

            // Ensure the browser paints the hidden state before transitioning to visible.
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                timerContainers.forEach((container) => container.classList.add('lto-timer--ready'));
              });
            });
          }

          // Initialize or get end time
          function getEndTime() {
            const stored = localStorage.getItem(STORAGE_KEY);
            const now = Math.floor(Date.now() / 1000); // Current time in seconds

            if (stored && parseInt(stored) > now) {
              return parseInt(stored);
            } else {
              // New end time (current time + total seconds)
              const newEnd = now + TOTAL_SECONDS;
              localStorage.setItem(STORAGE_KEY, newEnd.toString());
              return newEnd;
            }
          }

          // Update all timer displays with smooth transitions
          function updateTimers() {
            // Current time in seconds
            const now = Math.floor(Date.now() / 1000);

            // End time
            const endTime = getEndTime();

            // Calculate remaining seconds
            let remaining = endTime - now;

            // Reset if timer finished
            if (remaining <= 0) {
              // Reset the timer to original value
              const newEnd = now + TOTAL_SECONDS;
              localStorage.setItem(STORAGE_KEY, newEnd.toString());
              remaining = TOTAL_SECONDS;

              // Add a restart animation to all timers
              timerContainers.forEach((container) => {
                // Flash effect on restart
                container.classList.add('timer-restart');
                setTimeout(() => container.classList.remove('timer-restart'), 1000);
              });

              console.log('Timer completed and restarted!');
            }

            // Calculate minutes and seconds
            const mins = Math.floor(remaining / 60);
            const secs = remaining % 60;

            // Only update if values have changed
            const minutesChanged = mins !== prevMinutes;
            const secondsChanged = secs !== prevSeconds;

            if (minutesChanged || secondsChanged) {
              timerContainers.forEach((container) => {
                const minutesEl = container.querySelector('.minutes');
                const secondsEl = container.querySelector('.seconds');

                // Only update minutes if they've changed
                if (minutesChanged && minutesEl) {
                  minutesEl.textContent = mins < 10 ? '0' + mins : mins;

                  // Add a brief highlight effect when minutes change
                  minutesEl.classList.add('highlight');
                  setTimeout(() => minutesEl.classList.remove('highlight'), 300);
                }

                // Always update seconds
                if (secondsEl) {
                  secondsEl.textContent = secs < 10 ? '0' + secs : secs;
                }
              });

              // Remember current values
              prevMinutes = mins;
              prevSeconds = secs;

              // Fade in only after we have rendered the real value (prevents refresh flicker).
              revealTimers();
            }
          }

          // Start timer with 1-second interval
          function startTimer() {
            // Clear any existing timer
            clearInterval(timerId);

            // Update immediately
            updateTimers();

            // Then update every second
            timerId = setInterval(updateTimers, 1000);
          }

          // Stop timer
          function stopTimer() {
            clearInterval(timerId);
            timerId = null;
          }

          // Handle visibility changes
          document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
              stopTimer();
            } else {
              startTimer();
            }
          });

          // Sync with other tabs
          window.addEventListener('storage', function (e) {
            if (e.key === STORAGE_KEY) {
              updateTimers();
            }
          });

          // Clean up on unload
          window.addEventListener('beforeunload', stopTimer);

          // Start timer
          startTimer();
        }

        function setupProductToggle() {
          const viewProductsBtn = document.querySelector('.view-products').parentNode;
          const closeProductsBtn = document.querySelector('.close-products-container');
          const productContainer = document.querySelector('.product-container');
          const productImage = document.querySelector('.product-image');
          const mobileDesign = document.querySelector('.mobile-design');

          // Initially hide product container
          if (productContainer) {
            productContainer.style.display = 'none';
          }

          // Show product container, hide image and hide the view button when clicking view products
          if (viewProductsBtn) {
            viewProductsBtn.addEventListener('click', function () {
              if (productContainer) productContainer.style.display = 'grid';
              if (productImage) productImage.style.display = 'none';
              viewProductsBtn.style.display = 'none';
              if (mobileDesign) mobileDesign.classList.add('active-mobile-card');
            });
          }

          // Show image, hide product container and show the view button when clicking close button
          if (closeProductsBtn) {
            closeProductsBtn.addEventListener('click', function () {
              if (productContainer) productContainer.style.display = 'none';
              if (productImage) productImage.style.display = 'block';
              if (viewProductsBtn) viewProductsBtn.style.display = 'flex';
              if (mobileDesign) mobileDesign.classList.remove('active-mobile-card');
            });
          }

          // Add click handler for the Try Now mobile button
          const tryNowMobileBtn = document.querySelector('.try-now-mobile-active');
          if (tryNowMobileBtn && closeProductsBtn) {
            tryNowMobileBtn.addEventListener('click', function () {
              closeProductsBtn.click();
            });
          }
        }



        document.addEventListener('DOMContentLoaded', function () {
          // Video modal functionality
          const playButton = document.querySelector('.playButton');
          const videoModal = document.getElementById('videoModal');
          const modalContent = videoModal?.querySelector('div');
          const closeButton = document.getElementById('closeButton');
          const youtubeVideo = document.getElementById('youtubeVideo');
          const youtubeVideoUrl = 'https://www.youtube.com/embed/wCqBmyubRZ0?wmode=opaque'; // Get video URL from schema

          // Open modal and play video
          playButton?.addEventListener('click', function () {
            videoModal.style.display = 'flex';
            setTimeout(() => {
              videoModal.classList.add('bg-opacity-80');
              modalContent.classList.remove('opacity-0', 'scale-95');
              modalContent.classList.add('opacity-100', 'scale-100');
            }, 10);
            youtubeVideo.src = youtubeVideoUrl;
            document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
          });

          // Close modal and stop video
          closeButton?.addEventListener('click', function () {
            videoModal.classList.remove('bg-opacity-80');
            modalContent.classList.remove('opacity-100', 'scale-100');
            modalContent.classList.add('opacity-0', 'scale-95');

            setTimeout(() => {
              videoModal.style.display = 'none';
              youtubeVideo.src = ''; // Stop the video by removing the source
            }, 300);
            document.body.style.overflow = ''; // Re-enable scrolling
          });

          // Close modal when clicking outside the content
          videoModal?.addEventListener('click', function (event) {
            if (event.target === videoModal) {
              closeButton.click();
            }
          });

          // Close modal with Escape key
          document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && videoModal.style.display === 'flex') {
              closeButton.click();
            }
          });
        });



        document.addEventListener('DOMContentLoaded', function () {
          const faqButtons = document.querySelectorAll('.faq-button');

          // Open first accordion by default
          if (faqButtons.length > 0) {
            const firstButton = faqButtons[0];
            const firstPanel = firstButton.nextElementSibling;
            const firstArrow = firstButton.querySelector('.faq-arrow');

            firstButton.classList.add('active');
            firstPanel.style.maxHeight = firstPanel.scrollHeight + 'px';
            firstArrow.style.transform = 'rotate(180deg)';
          }

          faqButtons.forEach((button) => {
            button.addEventListener('click', () => {
              const panel = button.nextElementSibling;
              const arrow = button.querySelector('.faq-arrow');

              // Toggle active class
              button.classList.toggle('active');

              // Toggle panel visibility
              if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                arrow.style.transform = 'rotate(0deg)';
              } else {
                panel.style.maxHeight = panel.scrollHeight + 'px';
                arrow.style.transform = 'rotate(180deg)';
              }

              // Close other panels
              faqButtons.forEach((otherButton) => {
                if (otherButton !== button) {
                  const otherPanel = otherButton.nextElementSibling;
                  const otherArrow = otherButton.querySelector('.faq-arrow');
                  otherButton.classList.remove('active');
                  otherPanel.style.maxHeight = null;
                  otherArrow.style.transform = 'rotate(0deg)';
                }
              });
            });
          });
        });



      (function () {
        const sticky = document.querySelector('[data-sticky-cta]');
        const buybox = document.getElementById('shopify-section-buybox-hero');
        const mainCta = document.querySelector('[data-buybox-main-cta]');
        if (!sticky || !buybox || !mainCta) return;

        new IntersectionObserver(
          ([e]) => {
            const pastMainCta = !e.isIntersecting && e.boundingClientRect.bottom < 0;
            sticky.classList.toggle('is-visible', pastMainCta);
          },
          { threshold: 0 },
        ).observe(mainCta);

        const scrollToBuybox = () => buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const link = sticky.querySelector('[data-sticky-cta-link]');
        if (link) {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            scrollToBuybox();
          });
        }


      })();

      (function () {
        const banner = document.querySelector('[data-announcement-bar]');
        const buybox = document.getElementById('shopify-section-buybox-hero');
        if (!banner || !buybox) return;

        const scrollToBuybox = () => buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });

        if (banner) {
          banner.addEventListener('click', scrollToBuybox);
          banner.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              scrollToBuybox();
            }
          });
        }
      })();


      /* Pass 1 — interactivity bootstrap.
       * Most section-level JS is already inline within the rendered markup
       * (FAQ accordion, modal toggles, countdown). This file is for shared/global
       * helpers and to lazily promote `data-src` images that would normally be
       * hydrated by the theme's lozad observer. */

      document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('img.lozad[data-src]').forEach((img) => {
          if (!img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
        });
        document.querySelectorAll('source[data-srcset]').forEach((s) => {
          if (!s.getAttribute('srcset')) s.setAttribute('srcset', s.getAttribute('data-srcset'));
        });

        initUpsellModal();
        initBuyBoxCarousel();
        initReviewsMarquees();
      });

      function initReviewsMarquees() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        document.querySelectorAll('[id="reviews-swiper"]').forEach((root) => {
          const wrapper = root.querySelector('.swiper-wrapper');
          if (!wrapper) return;
          const slides = Array.from(wrapper.children);
          if (slides.length === 0) return;

          slides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));

          const start = () => {
            const firstClone = wrapper.children[slides.length];
            const loopDistance = firstClone.offsetLeft;
            if (!loopDistance) {
              requestAnimationFrame(start);
              return;
            }

            const speed = 60; // px/sec
            let offset = 0;
            let last = performance.now();
            let paused = false;

            root.addEventListener('mouseenter', () => {
              paused = true;
            });
            root.addEventListener('mouseleave', () => {
              paused = false;
            });
            root.addEventListener(
              'touchstart',
              () => {
                paused = true;
              },
              { passive: true },
            );
            root.addEventListener('touchend', () => {
              paused = false;
            });
            root.addEventListener('touchcancel', () => {
              paused = false;
            });

            function tick(now) {
              const dt = now - last;
              last = now;
              if (!paused) {
                offset -= (speed * dt) / 1000;
                if (-offset >= loopDistance) offset += loopDistance;
                wrapper.style.transform = `translateX(${offset}px)`;
              }
              requestAnimationFrame(tick);
            }
            requestAnimationFrame(tick);
          };

          requestAnimationFrame(start);
        });
      }

      function initBuyBoxCarousel() {
        const root = document.querySelector('[data-buybox]');
        if (!root) return;

        const heroImg = root.querySelector('[data-buybox-hero-img]');
        const thumbs = Array.from(root.querySelectorAll('[data-buybox-thumb]'));
        const prev = root.querySelector('[data-buybox-prev]');
        const next = root.querySelector('[data-buybox-next]');
        if (!heroImg || thumbs.length === 0) return;

        let current = 0;

        function scrollThumbIntoView(thumb) {
          const thumbRow = thumb.closest('[data-buybox-thumbs]');
          if (!thumbRow || thumbRow.scrollWidth <= thumbRow.clientWidth) return;

          const rowRect = thumbRow.getBoundingClientRect();
          const thumbRect = thumb.getBoundingClientRect();
          const targetLeft =
            thumbRow.scrollLeft +
            thumbRect.left -
            rowRect.left -
            (thumbRow.clientWidth - thumbRect.width) / 2;
          const maxScrollLeft = thumbRow.scrollWidth - thumbRow.clientWidth;

          thumbRow.scrollTo({
            left: Math.min(Math.max(0, targetLeft), maxScrollLeft),
            behavior: 'smooth',
          });
        }

        function activate(index) {
          current = (index + thumbs.length) % thumbs.length;
          const thumb = thumbs[current];
          heroImg.src = thumb.dataset.src;
          heroImg.alt = thumb.dataset.alt || '';
          heroImg.classList.toggle('object-contain', thumb.dataset.objectFit === 'object-contain');
          heroImg.classList.toggle('object-cover', thumb.dataset.objectFit !== 'object-contain');
          thumbs.forEach((t, i) => {
            t.classList.toggle('border-campo_red', i === current);
            t.classList.toggle('border-transparent', i !== current);
          });
          scrollThumbIntoView(thumb);
        }

        thumbs.forEach((t, i) => t.addEventListener('click', () => activate(i)));
        prev && prev.addEventListener('click', () => activate(current - 1));
        next && next.addEventListener('click', () => activate(current + 1));

        const hero = root.querySelector('[data-buybox-hero]');
        if (hero) {
          let touchStartX = 0;
          let touchStartY = 0;
          let touchDeltaX = 0;
          let touchDeltaY = 0;
          let isSwiping = false;

          hero.addEventListener(
            'touchstart',
            (e) => {
              if (e.touches.length !== 1) return;
              touchStartX = e.touches[0].clientX;
              touchStartY = e.touches[0].clientY;
              touchDeltaX = 0;
              touchDeltaY = 0;
              isSwiping = true;
            },
            { passive: true },
          );

          hero.addEventListener(
            'touchmove',
            (e) => {
              if (!isSwiping || e.touches.length !== 1) return;
              touchDeltaX = e.touches[0].clientX - touchStartX;
              touchDeltaY = e.touches[0].clientY - touchStartY;
            },
            { passive: true },
          );

          hero.addEventListener('touchend', () => {
            if (!isSwiping) return;
            isSwiping = false;
            const threshold = 40;
            if (
              Math.abs(touchDeltaX) > threshold &&
              Math.abs(touchDeltaX) > Math.abs(touchDeltaY)
            ) {
              activate(current + (touchDeltaX < 0 ? 1 : -1));
            }
          });

          hero.addEventListener('touchcancel', () => {
            isSwiping = false;
          });

          let pointerStartX = 0;
          let pointerStartY = 0;
          let pointerDown = false;

          hero.addEventListener('pointerdown', (e) => {
            if (e.pointerType !== 'mouse') return;
            pointerDown = true;
            pointerStartX = e.clientX;
            pointerStartY = e.clientY;
          });

          hero.addEventListener('pointerup', (e) => {
            if (!pointerDown || e.pointerType !== 'mouse') return;
            pointerDown = false;
            const dx = e.clientX - pointerStartX;
            const dy = e.clientY - pointerStartY;
            const threshold = 50;
            if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy)) {
              activate(current + (dx < 0 ? 1 : -1));
            }
          });

          hero.addEventListener('pointercancel', () => {
            pointerDown = false;
          });
        }
      }

      function initUpsellModal() {
        const configEl = document.querySelector('[data-try-checkout-config]');
        if (!configEl) return;

        let config;
        try {
          config = JSON.parse(configEl.textContent);
        } catch (e) {
          return;
        }

        const { mainProduct, freeProducts = [], upsellProduct, discounts = {} } = config;
        const storeDomain = 'https://eatcampogrande.com';
        const ctaEl = document.querySelector('[data-try-cta-one-time-price]');
        const otpDisplayPrice = (ctaEl && ctaEl.dataset.tryCtaOneTimePrice) || '$199';
        const otpTrackingPrice = parseFloat(otpDisplayPrice.replace(/[^0-9.]/g, '')) || 199;
        const purchaseOptions = {
          subscription: {
            option: 'subscription',
            displayPrice: '$149',
            trackingPrice: 149,
            compareAtPrice: 199,
            sellingPlanId: Number(mainProduct?.selling_plan_id) || null,
          },
          'one-time': {
            option: 'one-time',
            displayPrice: otpDisplayPrice,
            trackingPrice: otpTrackingPrice,
            compareAtPrice: null,
            sellingPlanId: null,
          },
        };
        const purchaseState = window.tryPurchaseState || {};
        let checkoutInFlight = false;

        window.tryPurchaseState = purchaseState;

        function buildPermalink(variants, discountCodes) {
          const items = variants.map((v) => `${v.variant_id}:${v.quantity}`).join(',');
          const codes = [].concat(discountCodes).filter(Boolean).join(',');
          return `${storeDomain}/cart/${items}?discount=${codes}`;
        }

        function setPurchaseOption(option) {
          const nextOption = purchaseOptions[option] || purchaseOptions.subscription;
          Object.assign(purchaseState, nextOption);
          const shouldUseMobileHidden = window.matchMedia('(max-width: 1023px)').matches;

          document.querySelectorAll('[data-try-purchase-option]').forEach((card) => {
            const isActive = card.dataset.tryPurchaseOption === purchaseState.option;
            const radio = card.querySelector('[data-try-option-radio]');
            const dot = card.querySelector('[data-try-option-dot]');
            const details = card.querySelector('[data-try-option-details]');
            const label = card.querySelector('[data-try-option-label]');
            const price = card.querySelector('[data-try-option-price]');
            const isSubscription = card.dataset.tryPurchaseOption === 'subscription';

            card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            card.classList.remove('bg-[#EBEED9]/50', 'bg-[#FBF7F5]', 'border-[#6B7A3A]', 'border-[#D3D3D3]');
            card.classList.add(isActive && isSubscription ? 'bg-[#EBEED9]/50' : 'bg-[#FBF7F5]');
            card.classList.add(isActive ? 'border-[#6B7A3A]' : 'border-[#D3D3D3]');

            if (radio) {
              radio.classList.remove('border-[#6B7A3A]', 'border-[#535353]');
              radio.classList.add(isActive ? 'border-[#6B7A3A]' : 'border-[#535353]');
            }
            if (dot) {
              dot.classList.remove('opacity-100', 'opacity-0');
              dot.classList.add(isActive ? 'opacity-100' : 'opacity-0');
            }
            if (details) {
              if (details._tryOptionHiddenTimer) {
                clearTimeout(details._tryOptionHiddenTimer);
              }
              if (isActive) {
                details.hidden = false;
              }
              details.classList.remove('mt-7', 'mt-4', 'mt-0', 'max-h-[400px]', 'max-h-[900px]', 'max-h-0', 'opacity-100', 'opacity-0');
              // details.classList.add(isActive ? (isSubscription ? 'mt-7' : 'mt-4') : 'mt-0');
              details.classList.add(isActive ? 'max-h-[900px]' : 'max-h-0');
              details.classList.add(isActive ? 'opacity-100' : 'opacity-0');
              details.style.maxHeight = isActive ? `${details.scrollHeight}px` : '0px';
              if (!isActive && shouldUseMobileHidden) {
                details._tryOptionHiddenTimer = setTimeout(() => {
                  if (card.getAttribute('aria-pressed') === 'false') {
                    details.hidden = true;
                  }
                }, 320);
              } else if (!shouldUseMobileHidden) {
                details.hidden = false;
              }
            }
            if (label) {
              label.classList.remove('text-[#3E1711]', 'text-[#535353]', 'text-[#4A2019]', 'text-gray-600');
              label.classList.add(isActive ? 'text-[#3E1711]' : 'text-[#535353]');
            }
            if (price) {
              price.classList.remove('text-[#3E1711]', 'text-[#272727]', 'text-gray-900', 'text-[#4A2019]');
              price.classList.add(isActive ? 'text-[#3E1711]' : 'text-[#272727]');
            }
          });

          document.querySelectorAll('[data-try-purchase-cta]').forEach((cta) => {
            const ctaPrice = cta.querySelector('[data-try-cta-price]');
            const ctaCompare = cta.querySelector('[data-try-cta-compare]');

            if (ctaPrice) ctaPrice.textContent = purchaseState.displayPrice;
            if (ctaCompare) {
              const hasSubscriptionOption = !!document.querySelector('[data-try-purchase-option="subscription"]');
              ctaCompare.classList.toggle('hidden', purchaseState.option !== 'subscription' && hasSubscriptionOption);
            }

            cta.dataset.trySelectedOption = purchaseState.option;
            cta.dataset.trySelectedPrice = purchaseState.trackingPrice.toFixed(2);
            if (purchaseState.sellingPlanId) {
              cta.dataset.trySellingPlanId = String(purchaseState.sellingPlanId);
            } else {
              delete cta.dataset.trySellingPlanId;
            }
          });

          document.dispatchEvent(
            new CustomEvent('try:purchase-option-change', {
              detail: { ...purchaseState },
            }),
          );
        }

        function initPurchaseOptions() {
          const options = document.querySelectorAll('[data-try-purchase-option]');
          if (!options.length) return;

          options.forEach((option) => {
            option.addEventListener('click', () => {
              setPurchaseOption(option.dataset.tryPurchaseOption || 'subscription');
            });
          });

          window.addEventListener('resize', () => {
            setPurchaseOption(purchaseState.option);
          });

          setPurchaseOption(config.defaultPurchaseOption || 'subscription');
        }

        function buildCartLine(product, purchaseOption) {
          const line = {
            id: Number(product.variant_id),
            quantity: Number(product.quantity) || 1,
          };

          if (purchaseOption === 'subscription') {
            const sellingPlanId = Number(product.selling_plan_id);
            if (!sellingPlanId) {
              throw new Error('Subscription checkout requires a selling plan.');
            }
            line.selling_plan = sellingPlanId;
          }

          if (product.properties) {
            line.properties = product.properties;
          }

          return line;
        }

        function getShopifyRoot() {
          return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        }

        async function clearCart() {
          const response = await fetch(getShopifyRoot() + 'cart/clear.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
            },
          });
          const data = await response.json().catch(() => null);

          if (!response.ok) {
            throw new Error((data && (data.description || data.message)) || 'Unable to clear cart.');
          }

          return data;
        }

        async function addItemsToCart(items) {
          const response = await fetch(getShopifyRoot() + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });
          const data = await response.json().catch(() => null);

          if (!response.ok) {
            throw new Error((data && (data.description || data.message)) || 'Unable to add item to cart.');
          }

          return data;
        }

        function redirectToCheckout(discountCodes) {
          const codes = []
            .concat(discountCodes)
            .filter(Boolean)
            .map((code) => encodeURIComponent(code))
            .join(',');
          const redirectPath = config.redirectPath || '/checkout';
          const separator = redirectPath.indexOf('?') === -1 ? '?' : '&';
          window.location.href = `${storeDomain}${redirectPath}${codes ? `${separator}discount=${codes}` : ''}`;
        }

        function showCheckoutError(error) {
          const loadingModal = document.querySelector('.loading-modal');
          if (loadingModal) loadingModal.style.display = 'none';
          console.error(error);
          alert("We couldn't add this offer to your cart. Please try again.");
        }

        async function checkoutSubscriptionBox(items, discountCodes) {
          if (checkoutInFlight) return;
          checkoutInFlight = true;
          const loadingModal = document.querySelector('.loading-modal');
          if (loadingModal) loadingModal.style.display = 'flex';

          try {
            await clearCart();
            await addItemsToCart(items);
            redirectToCheckout(discountCodes);
          } catch (error) {
            checkoutInFlight = false;
            showCheckoutError(error);
          }
        }



        async function handleSubscriptionBoxOneTimeCheckout(e) {
          e.preventDefault();
          const otpProduct = config.otpVariantId
            ? { ...mainProduct, variant_id: config.otpVariantId }
            : mainProduct;
          const items = [buildCartLine(otpProduct, 'one-time')];
          freeProducts.forEach((product) => {
            items.push(buildCartLine(product, 'one-time'));
          });
          const discountCodes = [discounts.base];
          if (discounts.gift) discountCodes.push(discounts.gift);
          await checkoutSubscriptionBox(items, discountCodes);
        }

        async function handleSubscriptionBoxOneTimeCheckoutWithUpsell(e) {
          e.preventDefault();
          closeModal();
          const otpProduct = config.otpVariantId
            ? { ...mainProduct, variant_id: config.otpVariantId }
            : mainProduct;
          const items = [buildCartLine(otpProduct, 'one-time')];
          freeProducts.forEach((product) => {
            items.push(buildCartLine(product, 'one-time'));
          });
          if (upsellProduct) {
            items.push(buildCartLine(upsellProduct, 'one-time'));
          }
          const discountCodes = [discounts.base, discounts.upsell];
          if (discounts.gift) discountCodes.push(discounts.gift);
          await checkoutSubscriptionBox(items, discountCodes);
        }

        async function handleSubscriptionBoxSubscriptionCheckout(e, includeUpsell) {
          e.preventDefault();
          closeModal();

          try {
            const items = [buildCartLine(mainProduct, 'subscription')];
            const discountCodes = [discounts.gift];

            freeProducts.forEach((product) => {
              items.push(buildCartLine(product, 'one-time'));
            });

            if (includeUpsell && upsellProduct) {
              items.push(buildCartLine(upsellProduct, 'one-time'));
              discountCodes.push(discounts.upsell);
            }

            await checkoutSubscriptionBox(items, discountCodes);
          } catch (error) {
            showCheckoutError(error);
          }
        }

        initPurchaseOptions();

        const acceptUrl = buildPermalink(
          [mainProduct, ...freeProducts, upsellProduct],
          [discounts.base, discounts.upsell, discounts.gift],
        );
        const declineUrl = buildPermalink(
          [mainProduct, ...freeProducts],
          [discounts.base, discounts.gift],
        );

        const modal = document.querySelector('[data-try-modal-panel]');
        if (!modal) return;

        function openModal(e) {
          e.preventDefault();
          modal.classList.remove('hidden');
          modal.classList.add('flex');
          document.body.style.overflow = 'hidden';
        }

        function closeModal() {
          modal.classList.add('hidden');
          modal.classList.remove('flex');
          document.body.style.overflow = '';
        }

        if (config.checkoutMode === 'subscriptionBox') {
          // Snapshot the shared selection when a CTA opens the modal.
          let openedPurchaseOption = purchaseState.option;

          document.addEventListener('click', (e) => {
            const button = e.target.closest('[data-try-place-order]');
            if (!button) return;
            openedPurchaseOption = purchaseState.option;
            openModal(e);
          });

          document.querySelectorAll('[data-try-close]').forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              closeModal();
            });
          });

          document.querySelectorAll('[data-try-upsell-accept]').forEach((btn) => {
            btn.addEventListener('click', (e) => {
              if (openedPurchaseOption === 'one-time') {
                handleSubscriptionBoxOneTimeCheckoutWithUpsell(e);
              } else {
                handleSubscriptionBoxSubscriptionCheckout(e, true);
              }
            });
          });

          document.querySelectorAll('[data-try-decline]').forEach((btn) => {
            btn.addEventListener('click', (e) => {
              if (openedPurchaseOption === 'one-time') {
                closeModal();
                handleSubscriptionBoxOneTimeCheckout(e);
              } else {
                handleSubscriptionBoxSubscriptionCheckout(e, false);
              }
            });
          });

          modal.addEventListener('click', (e) => {
            if (e.target === modal) closeModal();
          });

          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeModal();
          });

          return;
        }

        document.addEventListener('click', (e) => {
          const button = e.target.closest('[data-try-place-order]');
          if (!button) return;
          openModal(e);
        });

        document.querySelectorAll('[data-try-close]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            closeModal();
          });
        });

        document.querySelectorAll('[data-try-upsell-accept]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            window.location.href = acceptUrl;
          });
        });

        document.querySelectorAll('[data-try-decline]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            window.location.href = declineUrl;
          });
        });

        /* Close on backdrop click (clicking the dark overlay, not the card) */
        modal.addEventListener('click', (e) => {
          if (e.target === modal) closeModal();
        });

        /* Close on Escape */
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeModal();
        });
      }



      // Meta Pixel — fire ViewContent for this landing page
  // let mvcTries = 0;
  // const fireViewContent = () => {
  //   if (typeof window.fbq === 'function') {
  //     window.fbq('track', 'ViewContent', {
  //       content_name: 'Most Marbled Meat',
  //       content_category: 'Landing Page',
  //     });
  //   } else if (mvcTries++ < 25) {
  //     setTimeout(fireViewContent, 200);
  //   }
  // };
  // fireViewContent();



      (function () {
        function setupProgressive(flows) {
          var nodes = [];
          flows.forEach(function (f) {
            if (!f.scope) return;
            Array.from(f.scope.querySelectorAll(f.gridSel + ',' + f.ctaSel)).forEach(function (el) {
              nodes.push({ el: el, isCta: el.matches(f.ctaSel) });
            });
          });
          if (!nodes.length) return;

          var items = [];
          var current = null;
          nodes.forEach(function (n) {
            if (n.isCta) {
              if (current) {
                items.push(current);
                current = null;
              }
              items.push({ type: 'cta', el: n.el });
            } else {
              if (!current) current = { type: 'block', els: [] };
              current.els.push(n.el);
            }
          });
          if (current) items.push(current);

          var firstBlockIdx = items.findIndex(function (i) {
            return i.type === 'block';
          });
          if (firstBlockIdx === -1) return;

          items.forEach(function (item) {
            if (item.type === 'block')
              item.els.forEach(function (e) {
                e.classList.add('cg-hidden');
              });
            else item.el.classList.add('cg-hidden');
          });
          items[firstBlockIdx].els.forEach(function (e) {
            e.classList.remove('cg-hidden');
          });

          var revealedIdx = firstBlockIdx;

          function hasBlockAfter(idx) {
            for (var i = idx + 1; i < items.length; i++) {
              if (items[i].type === 'block') return true;
            }
            return false;
          }

          function attachViewMore(ctaEl) {
            if (ctaEl.querySelector('.cg-view-more')) return;
            var anchor = ctaEl.querySelector('a');
            if (!anchor) return;
            ctaEl.classList.add('cg-cta-row');
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'cg-view-more';
            btn.textContent = 'See More Reviews';
            btn.addEventListener('click', function () {
              ctaEl.classList.add('cg-hidden');
              advance();
            });
            anchor.parentNode.insertBefore(btn, anchor);
          }

          function revealCtaAfter(blockIdx) {
            for (var i = blockIdx + 1; i < items.length; i++) {
              if (items[i].type === 'cta') {
                items[i].el.classList.remove('cg-hidden');
                if (hasBlockAfter(i)) attachViewMore(items[i].el);
                revealedIdx = i;
                return;
              }
              if (items[i].type === 'block') return;
            }
          }

          function advance() {
            var nextBlockIdx = -1;
            for (var i = revealedIdx + 1; i < items.length; i++) {
              if (items[i].type === 'block') {
                nextBlockIdx = i;
                break;
              }
            }
            if (nextBlockIdx === -1) return;
            items[nextBlockIdx].els.forEach(function (e) {
              e.classList.remove('cg-hidden');
            });
            revealedIdx = nextBlockIdx;
            revealCtaAfter(nextBlockIdx);
          }

          // Initial: show the first cta after the first block (with View More if more blocks remain)
          revealCtaAfter(firstBlockIdx);
        }

        function init() {
          var sec1 = document.getElementById(
            'shopify-section-customer_media_testimonials_grid',
          );
          var sec2 = document.getElementById('shopify-section-customer_media_grid');
          var isDesktop = window.matchMedia('(min-width: 768px)').matches;

          // Run a single combined flow per viewport so section 2 continues
          // section 1's progressive disclosure without a separate restart.
          if (isDesktop) {
            setupProgressive([
              { scope: sec1, gridSel: '.cg-grid-1d', ctaSel: '.cg-cta-1d' },
              { scope: sec2, gridSel: '.cg-grid-2', ctaSel: '.cg-cta-2' },
            ]);
          } else {
            setupProgressive([
              { scope: sec1, gridSel: '.cg-grid-1m', ctaSel: '.cg-cta-1m' },
              { scope: sec2, gridSel: '.cg-grid-2', ctaSel: '.cg-cta-2' },
            ]);
          }
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
        } else {
          init();
        }
      })();
